export default "__VITE_ASSET__DleYKC_k__"